
export const convertUtcToIst = (utcDate) => {
  // Convert UTC to IST (UTC + 5:30)
  const istDate = new Date(utcDate.getTime() + 5.5 * 60 * 60 * 1000);

  // Format the date to ISO string and slice it to match the format
  const istTime = istDate.toISOString().slice(0, 16);
  return istTime;
};
export function getPolicyFormattedDate(dateString) {
  const date = dateString ? new Date(dateString) : new Date();

  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
  };

  return date
    .toLocaleDateString("en-US", options);
}
export const statusHandler = (status) => {
  console.log(status, "statusstatus");

  switch (status) {
    case "pendingLead":
      return "Booked";
    case "Pending":
      return "pending";
    case "activeLead":
      return "toDo";
    case "Booked":
      return "Booked";
    case "Sold":
      return "completed";
    case "Blocked":
      return "onHold";
    case "onHold":
      return "onHold";
    case "inProgress":
      return "inProgress";
    case "Available":
      return "toDo";
    case "pending":
      return "pending";
    case "completed":
      return "completed";
    case "todo":
      return "toDo";
    case "read_only":
      return "readOnlyStatus";
    case "read_write":
      return "readWriteStatus";
    case "manage":
      return "manageStatus";
    default:
      return "dynamicStatus";
  }
};

export const capitalizeFirstLetter = (str) => {
  if (!str) return str; // Return the string as is if it's empty or undefined

  // Capitalize the first letter
  const capitalized = str.charAt(0).toUpperCase() + str.slice(1);

  // Remove the trailing "s" if it exists
  return capitalized.endsWith("s") ? capitalized.slice(0, -1) : capitalized;
};

export function pluralizeLastWord(inputString) {
  // Split the string into words
  const words = inputString.split(" ");

  // Get the last word
  const lastWord = words[words.length - 1];

  // Define the pluralization rules
  let pluralWord;
  if (lastWord.endsWith("y")) {
    pluralWord = lastWord.slice(0, -1) + "ies"; // Change "y" to "ies"
  } else if (
    lastWord.endsWith("s") ||
    lastWord.endsWith("x") ||
    lastWord.endsWith("z") ||
    lastWord.endsWith("ch") ||
    lastWord.endsWith("sh")
  ) {
    pluralWord = lastWord + "es"; // Add "es" for words ending in "s", "x", "z", "ch", or "sh"
  } else {
    pluralWord = lastWord + "s"; // Default rule: Add "s"
  }

  // Replace the last word with its plural form
  words[words.length - 1] = pluralWord;

  // Join the words back into a sentence and return it
  return words.join(" ");
}

export function singularizeLastWord(inputString) {
  // Split the string into words
  const words = inputString.split(" ");

  // Get the last word
  const lastWord = words[words.length - 1];

  // Define the singularization rules
  let singularWord;

  // If the word ends with 'ies', change it to 'y'
  if (lastWord.endsWith("ies")) {
    singularWord = lastWord.slice(0, -3) + "y"; // Change "ies" to "y"
  }
  // If the word ends with 'es', remove the 'es'
  else if (
    lastWord.endsWith("es") &&
    !(
      lastWord.endsWith("xes") ||
      lastWord.endsWith("ches") ||
      lastWord.endsWith("shes")
    )
  ) {
    singularWord = lastWord.slice(0, -2); // Remove "es"
  }
  // If the word ends with 's', remove the 's' (general case like "accounts" -> "account")
  else if (lastWord.endsWith("s")) {
    singularWord = lastWord.slice(0, -1); // Remove "s"
  } else {
    singularWord = lastWord; // If no plural form found, keep the word as it is
  }

  // Replace the last word with its singular form
  words[words.length - 1] = singularWord;

  // Join the words back into a sentence and return it
  return words.join(" ");
}

export const MAX_FILE_SIZE = 15 * 1024 * 1024;
export const formatFileSize = (sizeInBytes) => {
  if (sizeInBytes < 1024) {
    return `${sizeInBytes} bytes`; // Less than 1 KB
  } else if (sizeInBytes < 1024 * 1024) {
    return `${(sizeInBytes / 1024).toFixed(2)} KB`; // Less than 1 MB
  } else {
    return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`; // 1 MB or more
  }
};

export const formatStatus = (value) => {
  if (!value) return "-";
  return value
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
export const fileFieldMapping = {
  'jobSummaryAttachment': 'job summary',
  'resume': 'resume',
  'othersAttachment': 'others',
}
export const MAX_ATTACHMENT_FILE_SIZE_MB = 2;
export const MAX_ATTACHMENT_FILE_SIZE = MAX_ATTACHMENT_FILE_SIZE_MB * 1024 * 1024; // in bytes

export const ACCEPTED_DOCUMENT_TYPES = ".pdf,.doc,.docx,.rtf,.txt";

export const isPastDate = (targetDate) => {
  if (!targetDate) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0); // strip time from today
  const inputDate = new Date(targetDate);
  inputDate.setHours(0, 0, 0, 0); // strip time from targetDate
  return inputDate < today;
};

export const getCandidateStageCounts = (candidates) => {
  const normalizeCandidateStatus = (status) => {
    const normalizedStatus = String(status || "")
      .trim()
      .toLowerCase()
      .replace(/[\s-]+/g, "_");

    const statusMap = {
      applied: "new",
      sourced: "new",
      contacted: "new",
      pending: "new",
      submitted: "new",
      available: "new",
      inreview: "screening",
      in_review: "screening",
      on_hold: "screening",
      hold: "screening",
      interview_cleared: "interview",
      interviewing: "interview",
      offered: "offered",
      withdrawn: "withdrawn",
      rejected: "rejected",
      r1_rejected: "rejected",
      r2_rejected: "rejected",
      final_rejected: "rejected",
    };

    return statusMap[normalizedStatus] || normalizedStatus;
  };

  const stageMap = {
    New: ["new"],
    Screening: ["screening"],
    Shortlisted: ["shortlisted"],
    // Applied: ["Applied"],
    Interviewing: ["interview"],
    Hired: ["hired"],
    Rejected: ["rejected"],
    Offered: ["offered", "Offered"],
    Withdrawn: ["withdrawn", "Withdrawn"],
    Engaged: ["engaged"],

  };

  const stageCounts = {
    New: 0,
    Screening: 0,
    Shortlisted: 0,
    // Applied: 0,
    Interviewing: 0,
    Hired: 0,
    Rejected: 0,
    Offered: 0,
    Withdrawn: 0,
    Engaged: 0,
  };

  candidates.forEach(candidate => {
    const normalizedStatus = normalizeCandidateStatus(candidate.status);
    for (const [key, statuses] of Object.entries(stageMap)) {
      if (statuses.includes(normalizedStatus)) {
        stageCounts[key]++;
        break;
      }
    }
  });

  return stageCounts;
};

export const STAGE_DISPLAY_CONFIG = {
  New: { label: "New", color: "#6366F1" }, // Indigo
  Shortlisted: { label: "Shortlisted", color: "#F97316" }, // Orange
  // Applied: { label: "Applied", color: "#10B981" }, // Emerald
  Screening: { label: "Screening", color: "#3B82F6" }, // Blue
  Interviewing: { label: "Interview", color: "#8B5CF6" }, // Violet
  Offered: { label: "Offered", color: "#22C55E" }, // Green
  Hired: { label: "Hired", color: "#14B8A6" }, // Teal (new)
  Rejected: { label: "Rejected", color: "#EF4444" }, // Red
  Withdrawn: { label: "Withdrawn", color: "#EAB308" }, // Yellow (new)
  Engaged: { label: "Engaged", color: "#A855F7" }, // Purple (new)
};



export const formatDateOnly = (isoString) => {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export const formatJobTitle = (title = "") => {
  if (!title) return "-";
  return title
    .split("-")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ").replace('Other ', '');
};

export const extractS3KeyFlexible = (s3Url) => {
  if (!s3Url || typeof s3Url !== 'string') {
    return s3Url;
  }

  // Remove query parameters
  const cleanUrl = s3Url.split('?')[0];

  // Check if it's an S3 URL pattern
  const s3UrlPattern = /^https?:\/\/[^\/]+\.s3[^\/]*\.amazonaws\.com\//;

  if (s3UrlPattern.test(cleanUrl)) {
    // Extract everything after the domain
    const match = cleanUrl.match(/^https?:\/\/[^\/]+\.s3[^\/]*\.amazonaws\.com\/(.+)$/);
    if (match) {
      // Decode URL-encoded characters (e.g., %20 -> space, %28 -> (, %29 -> ))
      try {
        return decodeURIComponent(match[1]);
      } catch (error) {
        console.warn('Failed to decode URI component:', error);
        return match[1]; // Return encoded version if decoding fails
      }
    }
    return cleanUrl;
  }

  // Return as-is if not an S3 URL, but still decode if it contains encoded characters
  try {
    return decodeURIComponent(cleanUrl);
  } catch (error) {
    console.warn('Failed to decode URI component:', error);
    return cleanUrl;
  }
};
export const removeTimestamp = (filename) => {
  if (!filename || typeof filename !== 'string') {
    return filename; // Return as-is if not a valid string
  }

  // Pattern to match timestamp at the beginning followed by hyphen
  // Assumes timestamp is 13 digits (milliseconds since epoch) followed by hyphen
  const timestampPattern = /^\d{13}-/;

  if (timestampPattern.test(filename)) {
    return filename.replace(timestampPattern, '');
  }

  // Return original filename if no timestamp pattern found
  return filename;
};
export const validateS3File = (file, options = {}) => {
  const {
    maxSizeInMB = 10,
    allowedExtensions = []
  } = options;

  const errors = [];
  let valid = true;

  const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
  if (file.size > maxSizeInBytes) {
    errors.push(`File size exceeds ${maxSizeInMB}MB limit`);
    valid = false;
  }

  if (allowedExtensions.length > 0) {
    const extension = file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(extension)) {
      errors.push(`File extension .${extension} is not allowed`);
      valid = false;
    }
  }

  return {
    valid,
    error: errors.join(', '),
    errors
  };
};


export const generateS3Path = (moduleName, id) => {
  let user = null;
  const userStr = localStorage.getItem('user');
  if (userStr) {
    user = JSON.parse(userStr);
  }

  // Ensure userId is a string, not an object
  let userId = user?._id;
  if (userId && typeof userId === 'object' && userId.toString) {
    userId = userId.toString();
  } else if (userId) {
    userId = String(userId);
  } else {
    userId = 'anonymous';
  }

  // Ensure applicationId is a string
  const applicationId = id ? String(id) : '';

  return `${userId}/${moduleName}/${applicationId}`
}
